import React from 'react'
import { useTranslation } from 'next-i18next'
import { path } from 'ramda'
import { IconChevronLeft, Text } from '@machobear/design-system'
import { useSelector } from 'react-redux'

interface BackBtnProps {
  showText?: boolean
  iconSize?: 'small' | 'medium' | 'large' | 'xlarge'
}

const BackBtn: React.FC<BackBtnProps> = ({
  showText = false,
  iconSize = 'medium'
}) => {
  const building = useSelector(path(['listing', 'building']))
  const { t } = useTranslation()
  const backToRentalListings = () => {
    const citySlug =
      building && typeof building === 'object' && 'city' in building
        ? String(building.city).toLowerCase()
        : undefined

    if (citySlug) {
      const backUrl = `/rental-listings/city/${citySlug}`
      window.location.href = backUrl
    } else {
      window.location.href = '/rental-listings' // don't expect to hit
    }
  }

  const handleBack = () => {
    if (document.referrer.includes('/rental-listings')) {
      // if page is opened in new tab and origin tab is closed, we need to go back to the origin tab
      // (window.opener is null at this point & document.referrer.includes('/rental-listings/detail')
      // is false if the user comes from the rental-listings/city page
      if (window.opener === null) {
        window.location.href = document.referrer
        return
      }
      if (document.referrer.includes('/rental-listings/detail')) {
        // edge case for detail listing page to open another detail listing page from simliar listing section
        backToRentalListings()
        return
      }
      window.close()
    } else {
      backToRentalListings()
    }
  }

  return (
    <button
      onClick={handleBack}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer'
      }}
      aria-label="Go back"
    >
      <IconChevronLeft size={iconSize} />
      {showText && <Text weight="medium">{t('Go Back')}</Text>}
    </button>
  )
}

export default BackBtn
